import projectDetailsActionCreators from "Areas/Projects/projectDetails/redux/actionCreators";
import { getSummaryReportsForProjectId, getSummaryReportsInProgressForProjectId } from "Areas/Projects/projectDetails/redux/selectors";
import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getInProgress } from "../redux/selectors";
import Panel from "./panel";
const mapStateToProps = (state, ownProps) => ({
    summaryReports: getSummaryReportsForProjectId(state, ownProps.projectId),
    inProgress: getSummaryReportsInProgressForProjectId(state, ownProps.projectId) ||
        getInProgress(state, ownProps.data.DocumentId)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (_, projectId) => dispatch(projectDetailsActionCreators.getProjectSummaryReports(projectId)),
    onAdd: (data, summaryReportIds, completed, rejected) => {
        Promise.resolve(dispatch(actionCreators.createSummaryReportObjects(data, summaryReportIds))).then((promiseResult) => {
            if ((promiseResult === null || promiseResult === void 0 ? void 0 : promiseResult.response) !== undefined)
                completed && completed();
            else
                rejected && rejected();
        });
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(Panel);
